import { FrameOptions } from '../interface';
import { ResourceLoader } from '../core';
import { FRAME_TEXTURE_PACK, DEFAULT_FRAME_OPTIONS } from '../constant';
import { Container, Sprite, Texture } from 'pixi.js';

class Frame extends Container {
  public options: FrameOptions;
  public sprites: Array<Array<Sprite>>;

  constructor(options?: Partial<FrameOptions>) {
    super();
    this.options = { ...DEFAULT_FRAME_OPTIONS, ...(options || {}) };
    this.sprites = [];

    for (let y = 0; y < 3; y++) {
      this.sprites.push([]);
      for (let x = 0; x < 3; x++) {
        this.sprites[y].push(new Sprite(Texture.EMPTY));
        this.addChild(this.sprites[y][x]);
      }
    }

    this.setOptions(this.options);
  }

  public build(): void {
    const textures: Array<Texture> = ResourceLoader.loadGridTexture(
      FRAME_TEXTURE_PACK[this.options.theme].texture,
      FRAME_TEXTURE_PACK[this.options.theme].width,
      FRAME_TEXTURE_PACK[this.options.theme].height
    );

    for (let y = 0; y < 3; y++) {
      for (let x = 0; x < 3; x++) {
        this.sprites[y][x].texture = textures[y * 3 + x];

        if (y === 0) {
          this.sprites[y][x].y = -FRAME_TEXTURE_PACK[this.options.theme].height - this.options.margin.top;
        } else if (y === 1) {
          this.sprites[y][x].y = -this.options.margin.top;
          this.sprites[y][x].height = this.options.height + this.options.margin.top + this.options.margin.bottom;
        } else if (y === 2) {
          this.sprites[y][x].y = this.options.height + this.options.margin.bottom;
        }

        if (x === 0) {
          this.sprites[y][x].x = -FRAME_TEXTURE_PACK[this.options.theme].width - this.options.margin.left;
        } else if (x === 1) {
          this.sprites[y][x].x = -this.options.margin.left;
          this.sprites[y][x].width = this.options.width + this.options.margin.left + this.options.margin.right;
        } else if (x === 2) {
          this.sprites[y][x].x = this.options.width + this.options.margin.right;
        }
      }
    }
  }

  public setOptions(options: FrameOptions): void {
    const { margin: defaultMargin, ...defaultOptions } = DEFAULT_FRAME_OPTIONS;
    const { margin: currentMargin = {}, ...currentOptions } = this.options;
    const { margin: newMargin = {}, ...newOptions } = options;

    this.options = {
      ...defaultOptions,
      ...currentOptions,
      ...newOptions,
      margin: {
        ...defaultMargin,
        ...currentMargin,
        ...newMargin,
      },
    };

    this.build();
  }
}

export default Frame;
